import React from 'react';

import Icon from 'Core/Components/Icon';
import NavList from 'Site/Ui/NavList';

class MobileNav extends React.Component {
  constructor (props) {
    super(props);
    this.state = { expanded: false };
    this.toggleMenu = this.toggleMenu.bind(this);
  }

  toggleMenu () {
    let expanded = !this.state.expanded;
    this.setState({ expanded });
  }

  render () {
    const { expanded } = this.state;

    return (
      <div className={'MobileNav' + (expanded ? ' expanded' : '')}>
        <Icon fa={expanded ? 'times' : 'navicon'} onClick={this.toggleMenu}/>
        <NavList />
      </div>
    );
  }
};

export default MobileNav;



// WEBPACK FOOTER //
// ./client/Site/Ui/MobileNav.jsx